import React from 'react'
import { Form, Checkbox, Message } from 'semantic-ui-react'

const FormFieldCheckBox = props => {
  //console.log( "FFC", props )
  const { prompt, name, width, inline, required, nomessage, valid, error, ...inputProps } = props
  //console.log( inputProps )
  return(
    <Form.Field
      width={width}
      error={!valid}
      inline={inline}
      required={required}
    >
      {prompt!==undefined &&
      <label>{prompt?prompt:'\u2003'}</label>
      }
      <Checkbox name={name} {...inputProps}/>
      {(!nomessage && !valid) &&
      <Message error>{error}</Message>
      }
    </Form.Field>
  )
}

export default FormFieldCheckBox
